<app-admin-table>
  <table class="cg-table">
    <thead>
      <tr>
        <th>Version</th>
        <th>Build</th>
        <th>Release date</th>
        <th>Status</th>
        <th>Created by</th>
        <th>Last updated</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (release of releases(); track release._id) {
        <tr>
          <td>{{ release.versionNumber }}</td>
          <td>{{ release.buildNumber }}</td>
          <td>{{ release.releaseDate | date: 'dd MMM yyyy' }}</td>
          <td>
            <app-status-badge [variant]="statusVariant(release.status)">
              {{ release.status === 'PUBLISHED' ? 'Published' : 'Draft' }}
            </app-status-badge>
          </td>
          <td>{{ creatorName(release) }}</td>
          <td>{{ release.updatedAt | date: 'dd MMM yyyy, HH:mm' }}</td>
          <td>
            <div class="cg-admin-table-actions">
              <app-admin-button variant="ghost" type="button" (click)="view.emit(release)">View</app-admin-button>
              @if (showEdit()) {
                <app-admin-button variant="ghost" type="button" (click)="edit.emit(release)" [disabled]="!canEdit()">
                  Edit
                </app-admin-button>
              }
              @if (showCreate()) {
                <app-admin-button variant="ghost" type="button" (click)="duplicate.emit(release)" [disabled]="!canCreate()">
                  Duplicate
                </app-admin-button>
              }
              @if (showPublish()) {
                @if (release.status === 'PUBLISHED') {
                  <app-admin-button variant="ghost" type="button" (click)="unpublish.emit(release)" [disabled]="!canPublish()">
                    Unpublish
                  </app-admin-button>
                } @else {
                  <app-admin-button variant="ghost" type="button" (click)="publish.emit(release)" [disabled]="!canPublish()">
                    Publish
                  </app-admin-button>
                }
              }
              @if (showEdit()) {
                <app-admin-button variant="danger" type="button" (click)="remove.emit(release)" [disabled]="!canEdit()">
                  Delete
                </app-admin-button>
              }
            </div>
          </td>
        </tr>
      }
      @if (!loading() && releases().length === 0) {
        <tr>
          <td colspan="7" class="rn-table__empty">No release notes found.</td>
        </tr>
      }
    </tbody>
  </table>
</app-admin-table>
